
import React, { useState, useEffect } from "react";
import { Form, Col, Modal } from "react-bootstrap";
import PermissionOptions from "./PermissionOptions";
import {formToDeepObject} from "../../../../../util/Helpers";

const NewAdmin = ({show, onHide, addNewAdmin}) => {

  const [validated, setValidated] = useState(false);
  const [adminType, setAdminType] = useState(null);

  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() === true) {
      const formData = new FormData(form);
      onHide();
      addNewAdmin(formToDeepObject(Object.fromEntries(formData.entries()), "permissions"));
    }
    setValidated(true);
  }

  // Restore adminType state on Hide
  useEffect(() => {
    return _ => setAdminType(null);
  }, [show])
    
  return (
    <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            Create New Admin
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="firstName">
                <Form.Label >First name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="firstName"
                  autoComplete="off"
                />
                <Form.Control.Feedback  type="invalid">Please provide admin First Name</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="lastName">
                <Form.Label >Last name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="lastName"
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">Please provide admin Last Name</Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="email">
                <Form.Label >Email</Form.Label>
                <Form.Control 
                  type="email" 
                  required
                  name="email" 
                  pattern="[a-z0-9\._%+!$&*=^|~#%'`?{}/\-]+@([a-z0-9\-]+\.){1,}([a-z]{2,16})"
                  autoComplete="off"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide admin Email Address
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="adminLevel">
              <Form.Label >Admin Type</Form.Label>
                <Form.Control
                    required
                    as="select"
                    className="mr-sm-2"
                    custom
                    name="adminLevel"
                    onChange={e => setAdminType(e.currentTarget.value)}
                >
                    <option value=""></option>
                    <option value="1">Admin</option>
                    <option value="2">Super Admin</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Select the Admin Type
                </Form.Control.Feedback>


              </Form.Group>
            </Form.Row>
            {adminType === "1" && <PermissionOptions />}
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
            >
                Create
            </button>
        </Modal.Footer>
          </Form>
      </Modal>

        );
}

export default NewAdmin;